import { Menu, MenuItem, Typography } from "@mui/material";
import { NavBarRoute } from "../options/navBarOpt";

interface NavBarMenuProps {
    anchors: [] | HTMLElement[];
    menuId: string;
    handleCloseAnchors: (routeId?: string) => void;
    menuItems: NavBarRoute[];
}

const GenerateNavBarMenuMobile = ({ anchors, menuId, handleCloseAnchors, menuItems }: NavBarMenuProps) => {

    return (
        <Menu
            sx={{
                display: { xs: 'block', md: 'none', left: 100 },

                '& .MuiPaper-root': {
                    minWidth: 100,
                    bgcolor: '#DAE5F1',
                    '& p': {
                        fontSize: '14px',
                    },
                }
            }}
            id={menuId}
            anchorEl={anchors.find(x => x.id === menuId)}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={Boolean(anchors.some(x => x.id === menuId))}
            onClose={() => handleCloseAnchors()}
        >
            {menuItems.map((item) => (
                <MenuItem key={item.text} onClick={() => {
                    handleCloseAnchors(item.routeId)

                }}>
                    <Typography textAlign="center">{item.text}</Typography>
                </MenuItem>
            ))
            }
        </Menu>
    )
}

export default GenerateNavBarMenuMobile;